import { ref } from 'vue';

/**
 * 테이블 행 드래그 재정렬용 최소 컴포저블 (네이티브 HTML5 DnD).
 *
 * 그룹 인지: groupOf(item) 가 다른 두 행 사이에는 이동 불가(순서 깨짐 방지).
 * 한 화면에 여러 그룹(예: 콘텐츠타입/배너위치)이 섞여 있어도 같은 그룹 안에서만 재정렬된다.
 *
 * 사용:
 *   const { dragIndex, overIndex, onDragStart, onDragEnter, onDragEnd, onDrop } = useDragReorder();
 *   <tr @dragenter.prevent="onDragEnter(index, displayItems, groupOf)"
 *       @dragover.prevent @drop="onDrop(displayItems, groupOf, applyGroupOrder)" @dragend="onDragEnd">
 *     <span class="drag-handle" :draggable="true" @dragstart="onDragStart(index)">grip</span>
 *
 * applyGroupOrder(groupRowsInNewOrder) 콜백에서 sortOrder 재부여 + 서버 저장.
 */
export function useDragReorder() {
  const dragIndex = ref(-1);
  const overIndex = ref(-1);

  const onDragStart = (i) => {
    dragIndex.value = i;
  };

  // 같은 그룹일 때만 드롭 하이라이트 허용
  const onDragEnter = (i, list, groupOf) => {
    if (dragIndex.value === -1) return;
    if (groupOf && groupOf(list[dragIndex.value]) !== groupOf(list[i])) return;
    overIndex.value = i;
  };

  const onDragEnd = () => {
    dragIndex.value = -1;
    overIndex.value = -1;
  };

  const onDrop = (list, groupOf, applyGroupOrder) => {
    const from = dragIndex.value;
    const to = overIndex.value;
    onDragEnd();
    if (from < 0 || to < 0 || from === to) return;
    if (groupOf && groupOf(list[from]) !== groupOf(list[to])) return; // 다른 그룹으로 이동 불가

    const arr = [...list];
    const [moved] = arr.splice(from, 1);
    arr.splice(to, 0, moved);

    // 영향받은 그룹의 행만 새 표시 순서대로 추려 콜백에 전달
    const g = groupOf ? groupOf(list[from]) : null;
    const groupRows = groupOf ? arr.filter((it) => groupOf(it) === g) : arr;
    applyGroupOrder(groupRows);
  };

  return { dragIndex, overIndex, onDragStart, onDragEnter, onDragEnd, onDrop };
}
